import Vue from 'vue'

const userProject = {
  state: {
    userProject: [],
    selectedUserProject: {},
  },

  getters: {
    userProject(state) {
      return state.userProject
    },
    selectedUserProject(state) {
      return state.selectedUserProject
    },
  },

  mutations: {
    userProject(state, payload) {
      state.userProject = payload
    },
    selectedUserProject(state, payload) {
      state.selectedUserProject = JSON.parse(JSON.stringify(payload))
    },
  },

  actions: {
    setSelectedUserProject(context, payload) {
      context.commit('selectedUserProject', payload)
    },
    loadUserProject(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'UserProject'
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('userProject', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    loadSelectedUserProject(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'UserProject/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedUserProject', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    updateUserProject(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `UserProject/${payload.ID}`
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'user project updated'},
              {root: true}
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadUserProject')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    createUserProject(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `UserProject`
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'user project created'},
              {root: true}
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadUserProject')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    saveUserProject(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateUserProject', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createUserProject', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteUserProject(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `UserProject/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'user project deleted'},
              {root: true}
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadUserProject')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
  },
}

export default userProject
